import { FunctionComponent, ReactNode, useCallback } from 'react';
import { useNavigate } from 'react-router';
import { useNavigationPaths } from '../../propertyAssociation/useNavigationPaths';
import { ConversationModel } from '../models/ConversationModel';
import ConversationsListItem from './ConversationsListItem';

type Props = {
    activeConversationId: string;
    children?: ReactNode | ReactNode[];
    conversations: ConversationModel[];
    hasMore: boolean;
    onLoadMore: () => void;
    showGroups?: boolean;
};

const ConversationsList: FunctionComponent<Props> = ({ activeConversationId, children, conversations, hasMore, onLoadMore, showGroups = false }) => {
    const paths = useNavigationPaths();
    const navigate = useNavigate();

    const onSelectConversation = useCallback(
        showGroups ?(conversationId: string) => navigate(`${paths.messages}/groups/${conversationId}`) :(conversationId: string) => navigate(`${paths.messages}/conversations/${conversationId}`),
        [showGroups, paths]
    );

    return (
        <div className='conversations__list'>
            {children}
            {conversations?.map(x => (
                <ConversationsListItem
                    conversation={x}
                    isActive={!!x.conversationId && x.conversationId === activeConversationId}
                    key={x.conversationId}
                    onSelectConversation={onSelectConversation} />
            ))}

            {hasMore && <div className="py-3 px-4"><button type='button' className='btn btn-primary w-100' onClick={onLoadMore}>Ladda fler...</button></div>}
        </div>
    );
};

export default ConversationsList;
